import { CheckRow } from '@workspace/ui/components/check-row'
import { SpinnerRow } from '@workspace/ui/components/spinner-row'
import type { DiagnosticRow } from './types'

/**
 * Something of ours is running and the founder is waiting on it.
 *
 * Shared by the three self-resolving states (reading a deck, matching, minting
 * a sign-in link). They differ only in what is being waited on and what has
 * already finished, so they are one component with different words rather than
 * three near-identical ones.
 */
export function ProgressVisual({
  waitingOn,
  eta,
  rows = [],
}: {
  waitingOn: string
  /**
   * Roughly how long this takes. A spinner with no horizon reads as stuck
   * within about thirty seconds, and the founder reloads or leaves — so every
   * waiting state says what "normal" looks like, even when it's approximate.
   */
  eta?: string
  rows?: DiagnosticRow[]
}) {
  return (
    <div className="rounded-xl border border-border/40 bg-card/40 px-5 py-4">
      <SpinnerRow>{waitingOn}</SpinnerRow>
      {eta && <p className="mt-1.5 pl-6 text-[12.5px] text-muted-foreground">{eta}</p>}
      {rows.length > 0 && (
        <div className="mt-3 border-t border-border/40 pt-2.5">
          {rows.map((row) => (
            <CheckRow key={row.text} tone={row.tone}>
              {row.text}
            </CheckRow>
          ))}
        </div>
      )}
    </div>
  )
}
